import { Space, Switch, Typography } from 'antd';
import { TextProps } from 'antd/es/typography/Text';
import * as React from 'react';

import s from './ChooseSwitch.module.scss';

type ChooseSwitchProps = {
  checked: boolean;
  onChange: (f: boolean) => void;

  trueDisplayLabel: string;
  falseDisplayLabel: string;
  checkedChildren?: React.ReactNode;
  uncheckedChildren?: React.ReactNode;

  className?: string;
};

/**
 * делает текст жирным или нормальным в зависимости от статуса switch
 * @param value
 * @param template
 */
const getTextType = (value: boolean, template = true): TextProps['type'] => {
  return value === template ? undefined : 'secondary';
};

const ChooseSwitch: React.FC<ChooseSwitchProps> = ({
  trueDisplayLabel,
  falseDisplayLabel,
  checked,
  onChange,
  checkedChildren,
  uncheckedChildren,
  className,
}) => {
  return (
    <Space className={className}>
      <Typography.Text type={getTextType(checked, false)}>
        {falseDisplayLabel}
      </Typography.Text>
      <Switch
        className={s['choose-switch__switch']}
        onChange={onChange}
        checked={checked}
        checkedChildren={checkedChildren}
        unCheckedChildren={uncheckedChildren}
      />
      <Typography.Text type={getTextType(checked, true)}>
        {trueDisplayLabel}
      </Typography.Text>
    </Space>
  );
};

export default ChooseSwitch;
